(() => {
  if (window.__egjDrawingBound) return;
  window.__egjDrawingBound = true;

  const DRAG_THRESHOLD = 5;

  /* body.overflow-hidden is in gk-scroll-motion.js LOCK_CLASSES, so Lenis
     stops while the dialog is open. */
  const lockPage = (locked) => document.body.classList.toggle('overflow-hidden', locked);

  const setZoom = (dialog, zoomed, origin) => {
    const stage = dialog.querySelector('[data-egj-drawing-stage]');
    const toggle = dialog.querySelector('[data-egj-drawing-zoom]');
    if (!stage || !toggle) return;

    const img = toggle.querySelector('img');

    if (zoomed) {
      /* Hold the stage at its fitted height so the dialog doesn't grow, and
         let srcset pick a file sharp enough for the 2.5x width. */
      stage.style.height = stage.clientHeight + 'px';
      if (img) img.sizes = Math.round(stage.clientWidth * 2.5) + 'px';
    } else {
      stage.style.height = '';
    }

    dialog.classList.toggle('is-zoomed', zoomed);
    toggle.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
    toggle.setAttribute('aria-label', zoomed ? 'Zoom out of drawing' : 'Zoom drawing');

    if (!zoomed) {
      stage.scrollTo(0, 0);
      return;
    }

    const rx = origin ? origin.rx : 0.5;
    const ry = origin ? origin.ry : 0.5;
    requestAnimationFrame(() => {
      stage.scrollLeft = rx * stage.scrollWidth - stage.clientWidth * (origin ? origin.vx : 0.5);
      stage.scrollTop = ry * stage.scrollHeight - stage.clientHeight * (origin ? origin.vy : 0.5);
    });
  };

  const openDialog = (dialog, opener) => {
    if (!dialog || dialog.open) return;
    dialog._egjOpener = opener;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    lockPage(true);
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  };

  const bindDialog = (dialog) => {
    if (dialog.dataset.egjDrawingBound === 'true') return;
    dialog.dataset.egjDrawingBound = 'true';

    const stage = dialog.querySelector('[data-egj-drawing-stage]');
    const toggle = dialog.querySelector('[data-egj-drawing-zoom]');
    let drag = null;
    let dragged = false;

    dialog.addEventListener('close', () => {
      lockPage(false);
      setZoom(dialog, false);
      if (dialog._egjOpener && dialog._egjOpener.isConnected) dialog._egjOpener.focus({ preventScroll: true });
    });

    /* A click whose target is the <dialog> itself landed on the backdrop. */
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    });

    if (!stage || !toggle) return;

    toggle.addEventListener('click', (event) => {
      if (dragged) {
        dragged = false;
        return;
      }
      const zoomed = dialog.classList.contains('is-zoomed');
      if (zoomed) {
        setZoom(dialog, false);
        return;
      }
      const img = toggle.querySelector('img');
      const rect = (img || toggle).getBoundingClientRect();
      const stageRect = stage.getBoundingClientRect();
      const fromPointer = event.detail > 0 && rect.width > 0;
      setZoom(dialog, true, fromPointer ? {
        rx: Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width)),
        ry: Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height)),
        vx: (event.clientX - stageRect.left) / stageRect.width,
        vy: (event.clientY - stageRect.top) / stageRect.height,
      } : null);
    });

    /* Mouse drag pans the zoomed drawing; touch uses native overflow scrolling. */
    stage.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || !dialog.classList.contains('is-zoomed')) return;
      drag = { x: event.clientX, y: event.clientY, left: stage.scrollLeft, top: stage.scrollTop };
      dragged = false;
    });

    stage.addEventListener('pointermove', (event) => {
      if (!drag) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!dragged && Math.hypot(dx, dy) < DRAG_THRESHOLD) return;
      if (!dragged) {
        dragged = true;
        stage.setPointerCapture(event.pointerId);
        dialog.classList.add('is-dragging');
      }
      stage.scrollLeft = drag.left - dx;
      stage.scrollTop = drag.top - dy;
    });

    const endDrag = () => {
      drag = null;
      dialog.classList.remove('is-dragging');
    };
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-egj-drawing-open]');
    if (opener) {
      event.preventDefault();
      const dialog = document.getElementById(opener.dataset.egjDrawingOpen);
      if (!dialog) return;
      bindDialog(dialog);
      openDialog(dialog, opener);
      return;
    }

    const closer = event.target.closest('[data-egj-drawing-close]');
    if (closer) closeDialog(closer.closest('[data-egj-drawing]'));
  });
})();
